var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('a',{staticClass:"logo",attrs:{"href":_vm.url}},[_c('img',{attrs:{"src":"/img/crowdpower-logo.svg","height":"30","width":"auto","title":"CrowdPower"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }